module.exports = __webpack_public_path__ + "img/jkglt.99c83228.png";